import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import api from "../../lib/api";
import { Briefcase, ArrowRight, MapPin } from "lucide-react";
import { t } from "../../lib/i18n";

const TYPE_LABELS = { equity: "Equity", debt: "Deuda", mixed: "Mixto" };
const STATUS_LABELS = {
  interested: t("Interés inicial"),
  qualified: "Cualificado",
  engaged: t("En conversación"),
  committed: "Compromiso",
  declined: "Descartado",
};

export default function InvestorPortfolio() {
  const [interests, setInterests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const r = await api.get("/investor-interests/mine");
      setInterests(r.data || []);
      setLoading(false);
    })();
  }, []);

  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <span className="font-mono-label text-gold">{t("Cartera · Inversor")}</span>
        <h1 className="font-serif-display text-4xl md:text-5xl mt-3 mb-3">{t("Tus oportunidades activas")}</h1>
        <p className="text-muted-foreground mb-10 max-w-xl">
          {t("Cada vez que expresas interés en una oportunidad, queda registrada aquí. Sigue el estado del proceso.")}
        </p>

        {loading ? (
          <div className="hairline p-12 text-center bg-card">
            <span className="font-mono-label text-muted-foreground">{t("Cargando…")}</span>
          </div>
        ) : interests.length === 0 ? (
          <div className="hairline p-12 text-center bg-card">
            <Briefcase className="w-10 h-10 mx-auto text-muted-foreground mb-4" />
            <h3 className="font-serif-display text-2xl mb-2">{t("Aún no has expresado interés")}</h3>
            <Link to="/investor/marketplace" className="font-mono-label text-gold inline-flex items-center gap-1" data-testid="portfolio-empty-go-market">
              {t("Ir al marketplace")}{" "}<ArrowRight className="w-3 h-3" />
            </Link>
          </div>
        ) : (
          <div className="hairline">
            {interests.map((it, i) => {
              const co = it.company || {};
              const dt = co.deal_terms || {};
              return (
                <Link
                  key={it.interest_id}
                  to={`/investor/opportunity/${it.company_id}`}
                  className={`grid grid-cols-12 gap-4 px-6 py-5 bg-card hover:bg-bone ${i > 0 ? "hairline-t" : ""}`}
                  data-testid={`portfolio-row-${it.interest_id}`}
                >
                  <div className="col-span-12 md:col-span-4">
                    <span className="font-mono-label text-gold">{co.sector}</span>
                    <div className="font-serif-display text-xl">{co.name_blind || co.sector}</div>
                    <div className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
                      <MapPin className="w-3 h-3" /> {co.country}
                    </div>
                  </div>
                  <div className="col-span-6 md:col-span-2">
                    <div className="font-mono-label text-muted-foreground" style={{ fontSize: "0.55rem" }}>TIPO</div>
                    <div>{dt.investment_type ? TYPE_LABELS[dt.investment_type] : "—"}</div>
                  </div>
                  <div className="col-span-6 md:col-span-2">
                    <div className="font-mono-label text-muted-foreground" style={{ fontSize: "0.55rem" }}>ASK</div>
                    <div>{dt.investment_ask_eur ? `€${(dt.investment_ask_eur / 1_000_000).toFixed(1)}M` : "—"}</div>
                  </div>
                  <div className="col-span-6 md:col-span-2">
                    <div className="font-mono-label text-muted-foreground" style={{ fontSize: "0.55rem" }}>{t("TIR OBJ.")}</div>
                    <div>{dt.expected_irr_pct ? `${dt.expected_irr_pct}%` : "—"}</div>
                  </div>
                  <div className="col-span-6 md:col-span-2 text-right">
                    <span className="font-mono-label bg-gold/10 text-[#A16207] border border-gold/30 px-2 py-1">
                      {STATUS_LABELS[it.status] || it.status}
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}
